import { ReactNode } from "react";
import ReactLoading from "react-loading";
import clsx from "clsx";

import { Button as ShadcnButton } from "@/components/shadcn/ui/button";

type Props = {
  variant?:
    | "primary"
    | "primaryOutline"
    | "primaryGhost"
    | "primaryLink"
    | "secondary"
    | "secondaryOutline"
    | "secondaryGhost"
    | "neutral"
    | "neutralOutline"
    | "neutralGhost";
  size?: "small" | "medium" | "large" | "icon";
  layout?: "default" | "fullWidth";
  icon?: React.ReactNode;
  iconPosition?: "start" | "end";
  className?: string;
  children: ReactNode;
  click?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  btnType?: "submit" | "reset" | "button";
  form?: string;
  disabled?: boolean;
  isLoading?: boolean;
};

// MEMO: 横幅を%で指定したい場合はclassNameで対応(ex: className="w-4/5")
const Button: React.FC<Props> = ({
  variant,
  size,
  layout,
  icon,
  iconPosition = "start",
  className,
  children,
  click,
  btnType = "button",
  form,
  disabled,
  isLoading
}) => {
  const spinnerColor = (variant: string | undefined) => {
    switch (variant) {
      case "primaryOutline":
        return "#F45555";
      case "secondaryOutline":
        return "#00CECE";
      case "neutralOutline":
        return "#BFBFBF";
      default:
        return "#fff";
    }
  };

  return (
    <ShadcnButton
      variant={variant}
      size={size}
      layout={layout}
      className={clsx(
        className,
        icon && iconPosition === "start"
          ? "flex-row gap-8"
          : "flex-row-reverse gap-8"
      )}
      onClick={(e) => click?.(e)}
      type={btnType}
      disabled={disabled || isLoading}
      form={form}
    >
      {icon ? (
        <>
          {isLoading ? (
            <ReactLoading
              color={spinnerColor(variant)}
              width="2rem"
              height="2rem"
              type="spin"
            />
          ) : (
            <span className="">{icon}</span>
          )}
          {children}
        </>
      ) : (
        <div
          className={
            isLoading ? "flex flex-wrap items-center justify-center gap-8" : ""
          }
        >
          {isLoading && (
            <ReactLoading color="#fff" width="2rem" height="2rem" type="spin" />
          )}
          {children}
        </div>
      )}
    </ShadcnButton>
  );
};

export default Button;
